import { render, staticRenderFns } from "./ReadinessConfiguration.vue?vue&type=template&id=72278c24&scoped=true"
import script from "./ReadinessConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadinessConfiguration.vue?vue&type=style&index=0&id=72278c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72278c24",
  null
  
)

export default component.exports